import React from "react";
import LoginFields from "../Components/LoginFields";
import logo from "../assets/images/logo.png";
import "../assets/css/login.css";

const LoginPage = () => {
  return (
    <div className="flex flex-col items-center h-screen justify-center bg-gray-900 text-white">
      <div className="bg-gray-800 w-full h-screen mx-auto rounded-2xl flex flex-col md:flex-row">

        {/* Left Section */}
        <div className="relative w-full md:w-1/2 flex items-center justify-center p-6">
          <div className="farm-loginleft-image w-full rounded-lg"></div>
          <div className="absolute inset-0 flex items-center justify-center z-10">
            <img src={logo} alt="Logo" className="rounded-lg h-28 md:h-48 object-contain w-40 md:w-[rem]" />
          </div>
        </div>


        {/* Right Section */}
        <div className="w-full md:w-1/2 bg-white text-gray-900 rounded-lg flex justify-center items-center p-6">
          <LoginFields />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
